import React, { useState } from 'react'
import CreateLr from './CreateLr';
import GenericSpinnerLoader from '../../../loaders/GenericSpinnerLoader';

function CreateLrWrapper(props) {

    const [loading, setLoading] = useState(false);

    const refreshModal = () => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false)
        }, 100)
    }

    if(loading) {
        return <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%", width:"100%"}}>
            <GenericSpinnerLoader/>
        </div>
    }

    return <CreateLr {...props} refreshModal={refreshModal}/>

}

export default CreateLrWrapper